import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import colors from '../../../../../constants/colors';
import PublicationInfo from '../PublicationInfo';
import { axiosPath, path } from '../../../../../routing/helpers/router';
import minions from '../../../../../minions/minions';
import useIsMounted from '@/layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function UserItemListView({ elementID }) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMounted = useIsMounted();
  const loading = useSelector((state) => state.currentPage?.options?.loading);
  const itLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID],
  );
  const itLevel2 = useSelector(
    (state) => state.currentPage?.elementLevels?.level2?.[elementID],
  );
  const [showInfoModal, setShowInfoModal] = useState(false);

  const handleClick = useCallback(() => {
    if (!itLevel1 || loading) return;

    if (itLevel1?.isFolder) {
      navigate(
        path({
          name: 'user_module_documentManager_item_list',
          params: {
            moduleBridgeHex,
            parentItemHex: itLevel1?.hex,
            page: 1,
            filtersHex: 0,
          },
        }),
      );
    } else {
      setShowInfoModal(true);
    }
  }, [itLevel1, moduleBridgeHex]);

  const handleDownload = useCallback(
    async () =>
      axios
        .post(
          axiosPath('api_r_user_module_documentManager_item_publication_download'),
          {
            moduleBridgeHex,
            itemHex: itLevel1?.hex,
          },
        )
        .then(({ data }) => {
          if (isMounted.current) {
            window.open(data, '_blank');
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, itLevel1],
  );

  const renderTags = useCallback(
    () =>
      itLevel1?.tags?.map((t) => (
        <span
          key={t?.key}
          className="badge badge-xs ml-1 pl-1 pr-1"
          style={{
            backgroundColor: colors.paletteColors[t?.color],
            color: '#fff',
          }}
        >
          {t?.name}
        </span>
      )),
    [itLevel1],
  );

  return (
    <>
      <Container
        key={elementID}
        className="pt-1 pr-2 pb-3 pl-2"
        onDoubleClick={handleClick}
      >
        <div className="col-title" title="Información del documento">
          <span>
            {itLevel1?.isFolder && <AppRemixIcon icon="folder" filled />}
            {itLevel1?.fileName && minions.files.fileIcon(itLevel1?.fileName)}{' '}
            {itLevel1?.title || '...'}
          </span>
        </div>
        <div>{renderTags()}</div>
        <div className="col-options">
          <div className="options">
            {itLevel1?.fileName && (
              <span
                className="pointer pl-2 pr-2"
                title="Descargar archivo"
                onClick={handleDownload}
              >
                <AppRemixIcon icon="download-2" color={colors.gray700} />
              </span>
            )}
          </div>
        </div>
      </Container>
      <AppModal
        show={showInfoModal && itLevel2}
        title="Información"
        size="xl"
        onClose={() => setShowInfoModal(false)}
      >
        <PublicationInfo
          elementID={elementID}
          onClose={() => setShowInfoModal(false)}
        />
      </AppModal>
    </>
  );
}

const Container = styled.div`
  border-bottom: solid 1px lightgrey;
  overflow: auto;
  display: grid;
  grid-template-columns: 1fr 1fr 300px;

  .col-title {
    cursor: default;
  }
  .col-options {
    display: flex;
    justify-content: end;
    .options {
      display: none;
    }
  }

  &:hover {
    .options {
      display: flex;
    }
  }
`;
